import classNames from "classnames";
import * as React from "react";

// tslint:disable-next-line:no-var-requires
const styles = require("./AccountButton.scss");

// tslint:disable-next-line:no-empty
const noop = () => {};

interface ButtonProps {
    name?: string;
    value?: string;
    label?: string;
    disabled?: boolean;
    placeholder?: string;
    onClick: (e: React.BaseSyntheticEvent, f?: boolean) => void;
}

export const InputButton = (props: ButtonProps) => {
    return (
        <div className={styles.btnWrapper}>
            <input
                onClick={props.onClick}
                className={classNames(styles.btn, styles.inputBtn)}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={props.value}
            />
            <label className={styles.primaryLabel}>{props.label}</label>
            <label className={styles.icon}>&#9998;</label>
        </div>
    );
};

export const SelectButton = (props: ButtonProps) => {
    return (
        <div className={styles.btnWrapper}>
            <input
                onClick={props.onClick}
                onChange={noop}
                className={classNames(styles.btn, styles.dropDown)}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={props.value}
            />
            <label className={styles.primaryLabel}>{props.label}</label>
            <label className={classNames(styles.icon, styles.iconDropdown)}>
                &#10151;
            </label>
        </div>
    );
};
